export default function tracking() {
    let analytics = analyticstracker();

    let previousTrackingObject = JSON.parse(sessionStorage.getItem('trackingObject'));
    let currentTrackingObject = JSON.parse(document.querySelector('body').dataset.trackingInfo);

    let initialReferrer = sessionStorage.getItem('initialReferrer');

    if (!initialReferrer && document.referrer.indexOf(window.location.hostname) == -1) {
        sessionStorage.setItem('initialReferrer', document.referrer);
        initialReferrer = document.referrer;
        //Also add initialReferrer to tracking object
        currentTrackingObject.initialReferrer = initialReferrer;
    }

    if (previousTrackingObject) {
        let previousPageObject = String(previousTrackingObject.pageUrl).split('?')[0];
        let previousPage = String(document.referrer).split('?')[0];
        let currentPage = String(window.location.href).split('?')[0];

        if (currentPage != previousPage && previousPage == previousPageObject) {
            currentTrackingObject.previousPageFullUrl = previousTrackingObject.pageFullUrl;
            currentTrackingObject.previousPageName = previousTrackingObject.pageName;
            currentTrackingObject.previousPageType = previousTrackingObject.pageType;
            currentTrackingObject.previousPageUrl = previousTrackingObject.pageUrl;
            currentTrackingObject.previousPlatform = previousTrackingObject.platform;
            currentTrackingObject.previousBrand = previousTrackingObject.brand;
            currentTrackingObject.previousDealerID = previousTrackingObject.dealerID;
            currentTrackingObject.previousPageViewMode = previousTrackingObject.pageviewMode;
            currentTrackingObject.initialReferrer = initialReferrer;

        }

        // currentTrackingObject.pageName = 'wonderservice/quote';
        // currentTrackingObject.section = 'quote';

        document.querySelector('body').dataset.trackingInfo = JSON.stringify(currentTrackingObject);
        sessionStorage.setItem('trackingObject', document.querySelector('body').dataset.trackingInfo);
    } else {
        document.querySelector('body').dataset.trackingInfo = JSON.stringify(currentTrackingObject);

        sessionStorage.setItem('trackingObject', document.querySelector('body').dataset.trackingInfo);
    }

    if (currentTrackingObject.section && currentTrackingObject.section !== 'appointment') {
        analytics.trackImpression('page-impression');
    }

    /**
     * Click tracking
     */

    $('[data-tracking-event$=-click]').click(analytics.trackInteraction);

    /**
     * Contact form tracking
     */
        // Custom tracking
    let infoAddressLink = $('.info__address a');
    if (infoAddressLink.length > 0) {
        $(infoAddressLink).on('click', function () {
            const infoAddressLinkData = {
                event: 'button-click',
                info: {
                    buttonType: 'link',
                    buttonCategory: 'outbound-link',
                    buttonName: 'to-calculate-itinerary',
                    buttonPosition: 'service-single-info',
                    buttonText: infoAddressLink.text(),
                    buttonTarget: infoAddressLink.attr('href'),
                },
            };

            analytics.trackEvent(infoAddressLinkData);
        });
    }
    let infoPhoneLink = $('.info__phone a');
    if (infoPhoneLink.length > 0) {
        $(infoPhoneLink).on('click', function () {
            const infoPhoneLinkData = {
                event: 'button-click',
                info: {
                    buttonType: 'link',
                    buttonCategory: 'outbound-link',
                    buttonName: 'to-call',
                    buttonPosition: 'service-single-info',
                    buttonText: infoPhoneLink.text(),
                    buttonTarget: infoPhoneLink.attr('href'),
                },
            };

            analytics.trackEvent(infoPhoneLinkData);
        });
    }
    let infoMailLink = $('.info__email a');
    if (infoMailLink.length > 0) {
        $(infoMailLink).on('click', function () {
            const infoMailLinkData = {
                event: 'button-click',
                info: {
                    buttonType: 'link',
                    buttonCategory: 'outbound-link',
                    buttonName: 'to-mail',
                    buttonPosition: 'service-single-info',
                    buttonText: infoMailLink.text(),
                    buttonTarget: infoMailLink.attr('href'),
                },
            };

            analytics.trackEvent(infoMailLinkData);
        });
    }

}

function tryParse(jsonString) {
    try {
        JSON.parse(jsonString);
    } catch (error) {
        return false;
    }

    return true;
}
